/// <reference types="vite/client" />
import { StrictMode } from 'react'

import ReactDOM from 'react-dom/client'

import { initFeatureFlags } from '#lib/feature-flags/client'
import { getRuntimeConfig } from '#lib/runtime-config'
import { initSentry } from '#lib/sentry/client'

const rootElement = document.getElementById('root')!

async function bootstrap(): Promise<void> {
  try {
    getRuntimeConfig()
    initSentry()
    initFeatureFlags()
    const { Provider } = await import('./provider')
    ReactDOM.createRoot(rootElement).render(
      <StrictMode>
        <Provider />
      </StrictMode>,
    )
  } catch (error) {
    rootElement.textContent =
      error instanceof Error
        ? `Trevize could not start: ${error.message}`
        : 'Trevize could not start because its runtime configuration is invalid.'
  }
}

void bootstrap()
